export const NavigationConfigConstants = {
  GET_NAVIGATION_REQUEST: 'CHART/GET_NAVIGATION_REQUEST',
  GET_NAVIGATION_SUCCESS: 'CHART/GET_NAVIGATION_SUCCESS',
  GET_NAVIGATION_ERROR: 'CHART/GET_NAVIGATION_ERROR',

  GET_AVAILABLE_NAVIGATION_REQUEST: 'CHART/GET_AVAILABLE_NAVIGATION_REQUEST',
  GET_AVAILABLE_NAVIGATION_SUCCESS: 'CHART/GET_AVAILABLE_NAVIGATION_SUCCESS',
  GET_AVAILABLE_NAVIGATION_ERROR: 'CHART/GET_AVAILABLE_NAVIGATION_ERROR',

  GET_SUBNAVIGATION_REQUEST: 'CHART/GET_SUBNAVIGATION_REQUEST',
  GET_SUBNAVIGATION_SUCCESS: 'CHART/GET_SUBNAVIGATION_SUCCESS',
  GET_SUBNAVIGATION_ERROR: 'CHART/GET_SUBNAVIGATION_ERROR',

  GET_FEATURES_REQUEST: 'CHART/GET_FEATURES_REQUEST',
  GET_FEATURES_SUCCESS: 'CHART/GET_FEATURES_SUCCESS',
  GET_FEATURES_ERROR: 'CHART/GET_FEATURES_ERROR',

  GET_NAVIGATION_PERMISSION_SUCCESS: 'MENU/GET_NAVIGATION_PERMISSION_SUCCESS',
  GET_NAVIGATION_ORDER: 'MENU/GET_NAVIGATION_ORDER'
};
